import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { GlobalStateProvider } from './shared/contexts/GlobalUserContext';
import { env } from './env';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const domain = env.REACT_APP_AUTH0_DOMAIN
  ? env.REACT_APP_AUTH0_DOMAIN
  : '';
const clientId = env.REACT_APP_AUTH0_CLIENT_ID
  ? env.REACT_APP_AUTH0_CLIENT_ID
  : '';

root.render(
  <Router>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
    >
      <GlobalStateProvider>
        <App />
      </GlobalStateProvider>
    </Auth0Provider>
  </Router>
);
